export default "__VITE_ASSET__CVSrtKdv__"